import * as Yup from "yup";

// helpers
import { filedTooShort, REQUIRED_CAMPAIGN_NAME } from "@/globals/schemasErrorMessage.constants";

export const validationSchemaCreateCampaign = Yup.object().shape({
  name: Yup.string()
    .min(2, filedTooShort("Campaign name"))
    .max(100, "Campaign name is too long!")
    .required(REQUIRED_CAMPAIGN_NAME),
  purpose: Yup.mixed()
    .nullable()
    .required("Purpose required!")
});
